import { DocumentListComponent } from './components/document-list/document-list.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DocumentViewerComponent } from './components/document-viewer/document-viewer.component';
import { JobDetailsComponent } from './components/job-details/job-details.component';
import { TokenResolver } from './resolvers/token-resolver.service';
import { DocumentsResolver } from './resolvers/documents-resolver.service';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { JobsResolver } from './resolvers/jobs-resolver.service';
import { AssigneesComponent } from './components/job-details/assignees/assignees.component';
import { ChangeEtaComponent } from './components/job-details/change-eta/change-eta.component';
import { AddDocumentsComponent } from './components/job-details/add-documents/add-documents.component';
import { ChangeStatusComponent } from './components/job-details/change-status/change-status.component';
import { CommentFollowUpComponent } from './components/job-details/comment-follow-up/comment-follow-up.component';
import { RequestUpdateComponent } from './components/job-details/request-update/request-update.component';
import { PageType } from './models/enum/page-type.enum';
import { FollowUpResolver } from './resolvers/followup-resolver.service';
import { FollowUpEditComponent } from './components/follow-up-details/follow-up-edit/follow-up-edit.component';
import { FollowUpDetailsComponent } from './components/follow-up-details/follow-up-details.component';
import { NoteThreadComponent } from './components/job-details/note-thread/note-thread.component';
import { NoteThreadResolver } from './resolvers/note-thread-resolver.service';
import { ContactsListComponent } from './components/job-details/contacts-list/contacts-list.component';
import { ContactsResolver } from './resolvers/contacts-resolver.service';
import { RequestUpdateResolver } from './resolvers/request-update-resolver.service';
import { BoardProposalFormComponent } from './components/job-details/board-proposal-form/board-proposal-form.component';
import { BoardProposalsComponent } from './components/proposal-details/proposal-details.component';
import { BoardProposalsResolver } from './resolvers/board-proposals-resolver.service';
import { ProposalsQueueComponent } from './components/job-details/proposals-queue/proposals-queue.component';
import { DocumentSelectionComponent } from './components/document-selection/document-selection.component';
import { BoardJobResolver } from './resolvers/board-job-resolver.service';
import { CustomerProposalsResolver } from './resolvers/customer-proposals-resolver.service';
import { BoardProposalResolver } from './resolvers/board-proposal-resolver.service';
import { CustomerProposalResolver } from './resolvers/customer-proposal-resolver.service';
import { ProposalNoteThreadComponent } from './components/proposal-details/proposal-note-thread/proposal-note-thread.component';
import { ProposalCustomerThreadResolver } from './resolvers/proposal-customer-thread-resolver.service';
import { ProposalBoardThreadResolver } from './resolvers/proposal-board-thread-resolver.service';
import { ProposalRelevantContactsResolver } from './resolvers/proposal-relevant-contacts-resolver.service';
import { BoardMembersResolver } from './resolvers/board-members-resolver.service';
import { CustomerPreferencesResolver } from './resolvers/customer-preferences-resolver.service';
import { FormsComponent } from './components/forms/forms.component';
import { FormsResolver } from './resolvers/forms-resolver.service';
import { MyCloudComponent } from './components/my-cloud/my-cloud.component';
import { CloudDocumentsResolver } from './resolvers/cloud-documents-resolver.service';
import { PlainInfoComponent } from './components/plain-info/plain-info.component';
import { InfoResolver } from './resolvers/info.resolver';
import { CanCompleteJobResolver } from './resolvers/can-complete-job.resolver';
import { MyWorkComponent } from './components/job-details/my-work/my-work.component';
import { IsVendorResolver } from './resolvers/is-vendor.resolver';
import { ProposalDocumentsResolver } from './resolvers/proposal-documents-resolver.service';
import { MyWorkUrlResolver } from './resolvers/my-work-url.resolver';
import { DigitalLogFormRequestsComponent } from './components/job-details/digital-log/form-requests/digital-log-form-requests.component';
import { DigitalLogFormRequestsResolver } from './resolvers/digital-log-form-requests-resolver.service';
import { DigitalLogFormComponent } from './components/job-details/digital-log/form/digital-log-form.component';
import { DigitalLogFormResolver } from './resolvers/digital-log-form-resolver.service';
import { DigitalLogFormCalendarComponent } from './components/job-details/digital-log/form-calendar/digital-log-form-calendar.component';
import { MyWorkJobBriefInfoResolver } from './resolvers/my-work-job-brief-info.resolver';
import { LoginWizardComponent } from './components/login-wizard/login-wizard.component';
import { LoginCallbackComponent } from './components/login-wizard/login-callback/login-callback.component';
import { MyWorkAuthGuard } from './guards/my-work-auth.guard';
import { AccountsListComponent } from './components/login-wizard/accounts-list/accounts-list.component';
import { UserAccountsResolver } from './resolvers/user-accounts.resolver';
import { VirtualBinderWizardComponent } from './components/virtual-binder-wizard/virtual-binder-wizard.component';
import { BinderSetupDataResolver } from './resolvers/binder-setup-data.resolver';
import { VirtualBinderConfirmationComponent } from './components/virtual-binder-wizard/virtual-binder-confirmation/virtual-binder-confirmation.component';
import { BinderClassificationResolver } from './resolvers/binder-classification.resolver';
import { BinderDetailsResolver } from './resolvers/binder-details.resolver';
import { BinderWizardDetailsResolver } from './resolvers/binder-wizard-details.resolver';
import { ExpiredVirtualBinderComponent } from './components/virtual-binder/expired-virtual-binder/expired-virtual-binder.component';
import { HasJobShiftsResolver } from './resolvers/has-job-shifts.resolver';
import { SiteNotesComponent } from './components/site-notes/site-notes.component';
import { DeficienciesComponent } from './components/deficiencies/deficiencies.component';
import { SiteNoteItemResolver } from './resolvers/site-notes/site-note-item.resolver';
import { SiteNotesListResolver } from './resolvers/site-notes/site-notes.resolver';
import { SiteNoteViewComponent } from './components/site-notes/site-note-view/site-note-view.component';
import { SiteNoteAddComponent } from './components/site-notes/site-note-add/site-note-add.component';
import { DeficiencyViewComponent } from './components/deficiencies/deficiency-view/deficiency-view.component';
import { DeficiencyItemResolver } from './resolvers/deficiency-item.resolver';
import { DeficienciesListResolver } from './resolvers/deficiencies.resolver';
import { MyWorkAccountInfoResolver } from './resolvers/my-work-account-info.resolver';
import { SiteNotesAccountInfoResolver } from './resolvers/site-notes/site-notes-account-info.resolver';
import { DeficienciesAccountInfoResolver } from './resolvers/deficiencies-account-info.resolver';
import { AccountRouteUrlResolver } from './resolvers/account-route-url.resolver';
import { AuthPage } from './models/auth/auth-page.model';
import { DigitalLogbookComponent } from './components/virtual-binder/digital-logbook/digital-logbook.component';
import { DigitalLogbooksResolver } from './resolvers/digital-logbooks.resolver';
import { DigitalLogOnDemandAddComponent } from './components/job-details/digital-log/digital-log-on-demand-add/digital-log-on-demand-add.component';
import { DigitalLogOnDemandFormResolver } from './resolvers/digital-log-on-demand-form.resolver';
import { TermsOfUseComponent } from './components/terms-of-use/terms-of-use.component';
import { TermsOfUseResolver } from './resolvers/terms-of-use.resolver';
import { HasAcceptedTermsResolver } from './resolvers/has-accepted-terms.resolver';
import { BinderTargetEmailResolver } from './resolvers/binder-target-email.resolver';
import { BinderQrScanHistoryResolver } from './resolvers/binder-qr-scan-history.resolver';
import { BinderQrScansAccessResolver } from './resolvers/binder-qr-scans-access.resolver';
import { DocumentViewPageComponent } from './components/document-view-page/document-view-page.component';
import { DisabledVirtualBinderComponent } from './components/virtual-binder/disabled-virtual-binder/disabled-virtual-binder.component';
import { DigitalLogFormPhotosResolver } from './resolvers/digital-log-form-photos-resolver.service';
import { DigitalLogFormPhotosComponent } from './components/job-details/digital-log/form/photos/digital-log-form-photos.component';
import { HasWorkToDoResolverResolver } from './resolvers/has-work-to-do-resolver.resolver';
import { SiteNoteCompletionComponent } from './components/site-notes/site-note-completion/site-note-completion.component';
import { SiteNoteReadonlyResolver } from './resolvers/site-notes/site-note-readonly.resolver';
import { WorkforceReportComponent } from './components/workforce-report/workforce-report.component';
import { WorkforceReportBysiteComponent } from './components/workforce-report-bysite/workforce-report-bysite.component';
import { DlFormDocumentsComponent } from './components/dl-form-documents/dl-form-documents.component';
import { DlFormDocumentsResolver } from './resolvers/dl-form-documents.resolver';
import { ConfigureRoundsUserRightResolver } from './resolvers/configure-rounds-user-right.resolver';
import { DigitalLogConfigurationOnDemandFormResolver } from './resolvers/digital-log-config-on-demand-form.resolver';
import { DigitalLogConfigurationProfileResolver } from './resolvers/digital-log-configuration-profile.resolver';
import { BinderAccessComponent } from './components/virtual-binder/binder-access/binder-access.component';
import { IsBinderAndCustomerLegacy } from './resolvers/is-binder-legacy.resolver';
import { HasCustomerPermissionResolver } from './resolvers/has-customer-permission.resolver';
import { DocumentContainerResolver } from './resolvers/document-container-resolver.service';
import { HasBinderUserPermissionResolver } from './resolvers/has-binder-user-permission.resolver';
import { FieldsAttachmentsListComponent } from './components/job-details/digital-log/form-requests/fields-attachments-list/fields-attachments-list.component';
import { FieldsAttachmentsResolver } from './resolvers/digital-log/fields-attachments.resolver';
import { UnregisterComponent } from './components/unregister/unregister.component';
import { DeleteUserAccountComponent } from './components/unregister/delete-account/delete-user-account.component';
import { DeleteUserAccountResolver } from './resolvers/delete-user-account.resolver';
import { ProcedureFormBypassComponent } from './components/procedure-form-bypass/procedure-form-bypass.component';
import { ProcedureFormBypassResolver } from './resolvers/procedure-formBypass-resolver';
import { RejectBypassRequestComponent } from './components/procedure-form-bypass/reject-bypass-request/reject-bypass-request.component';
import { BinderSessionComponent } from './components/virtual-binder/binder-session/binder-session.component';
import { BinderSessionSetupDataResolver } from './resolvers/binder-session/binder-session-setup-data.resolver';
import { BinderSessionClassificationResolver } from './resolvers/binder-session/binder-session-classification.resolver';
import { BinderSessionDetailsResolver } from './resolvers/binder-session/binder-session-details.resolver';
import {BinderSessionConfirmationComponent} from './components/virtual-binder/binder-session/binder-session-confirmation/binder-session-confirmation.component';
import {BinderSessionCodeComponent} from './components/virtual-binder/binder-session/binder-session-code/binder-session-code.component';
import {BinderSessionCodeResolver} from './resolvers/binder-session/binder-session-code.resolver';
import {BinderSessionGuard} from './guards/binder-Session.guard';
import {BinderSessionConfirmationResolver} from './resolvers/binder-session/binder-session-confirmation.resolver';
import { BinderViewerComponent } from './components/virtual-binder/binder-viewer/binder-viewer.component';
import { BinderSessionStatusComponent } from './components/virtual-binder/binder-session/binder-session-status/binder-session-status.component';
import {BinderSessionStatusResolver} from './resolvers/binder-session/binder-session-status.resolver';
import { ProcedurePreApprovalResolver } from './resolvers/procedure-pre-approval.resolver';
import { ProcedurePreApprovalComponent } from './components/procedure-pre-approval/procedure-pre-approval.component';
import { RejectPreApprovalRequestComponent } from './components/procedure-pre-approval/reject-pre-approval-request/reject-pre-approval-request.component';
import { DigitalLogConfigurationProfileGroupsResolver } from './resolvers/digital-log-configuration-profile-groups.resolver';
import { DigitalLogFormRequestsActiveResolver } from './resolvers/digital-log-form-requests-active-resolver.service';
import { DigitalLogOnDemandFormCountResolver } from './resolvers/digital-log-on-demand-form-count.resolver';
import { ProcedureCopilotConfirmationComponent } from './components/procedure-copilot-confirmation/procedure-copilot-confirmation.component';
import { ProcedureCopilotConfirmationResolver } from './resolvers/procedure-copilot-confirmation.resolver';
import { ProcedureCopilotConfirmationExpiredComponent } from './components/procedure-copilot-confirmation-expired/procedure-copilot-confirmation-expired.component';
import { CopilotConfirmationProceduresListResolver } from './resolvers/copilot-confirmation-procedures-list.resolver';
import { CopilotConfirmationProceduresListComponent } from './components/copilot-confirmation-procedures-list/copilot-confirmation-procedures-list.component';
import { ProcedureStepFormDetailsComponent } from './components/procedure-step-form-details/procedure-step-form-details.component';
import { ProcedureStepFormDetailsResolver } from './resolvers/procedure-step-form-details.resolver';
import { ProcedureFormValidationsSkipResolver } from './resolvers/procedure-formValidationsSkip.resolver';
import { ProcedureFormValidationsSkipComponent } from './components/procedure-form-validations-skip/procedure-form-validations-skip.component';
import { RejectValidationsSkipRequestComponent } from './components/procedure-form-validations-skip/reject-validations-skip-request/reject-validations-skip-request.component';
import { ProcedureSummaryReviewComponent } from './components/procedure-summary-review/procedure-summary-review.component';
import { ProcedureSummaryReviewResolver } from './resolvers/procedure-summary-review.resolver';
import { ProcedureSummaryReviewExpiredComponent } from './components/procedure-summary-review-expired/procedure-summary-review-expired.component';

const routes: Routes = [
	{
		path: 'view',
		component: DocumentViewerComponent
	}, {
		path: 'login',
		component: LoginWizardComponent
	}, {
		path: 'unregister',
		component: UnregisterComponent
	}, {
		path: 'accounts',
		component: AccountsListComponent,
		canActivate: [MyWorkAuthGuard],
		resolve: {
			userAccounts: UserAccountsResolver
		}
	}, {
		path: 'callback',
		component: LoginCallbackComponent
	}, {
		path: '404',
		component: NotFoundComponent
	}, {
		path: 'binder-expired',
		component: ExpiredVirtualBinderComponent
	},
	{
		path: 'binder-disabled',
		component: DisabledVirtualBinderComponent
	},
	{
		path: 'viewdoc/:oid/:documentId',
		children: [
			{
				path: '',
				component: DocumentViewPageComponent
			},
			{
				path: 'th',
				component: DocumentViewPageComponent
			}
		]
	}, {
		path: 'workforce-report/:assetId',
		children: [
			{
				path: '',
				component: WorkforceReportComponent
			}
		]
	}, {
		path: 'workforce-report-bysite/:siteId',
		children: [
			{
				path: '',
				component: WorkforceReportBysiteComponent
			}
		]
	}, {
		path: 'binder',
		children: [
			{
				path: '',
				component: BinderAccessComponent
			}
		]
	}, {
		path: ':token/procedure-confirmation-expired',
		children: [
			{
				path: '',
				component: ProcedureCopilotConfirmationExpiredComponent
			}
		]
	},  {
		path: ':token/procedure-summary-review-expired',
		children: [
			{
				path: '',
				component: ProcedureSummaryReviewExpiredComponent
			}
		]
	}, 
	{
		path: ':token',
		resolve: [TokenResolver],
		children: [
			{
				path: 'photo-viewer',
				component: DlFormDocumentsComponent,
				resolve: {
					documents: DlFormDocumentsResolver
				}
			},
			{
				path: 'documents',
				component: DocumentListComponent,
				resolve: {
					documents: DocumentsResolver,
					details: DocumentContainerResolver
				}
			}, {
				path: 'info',
				component: PlainInfoComponent,
				resolve: {
					payload: InfoResolver
				}
			}, {
				path: 'my-work',
				children: [{
					path: '',
					component: MyWorkComponent,
					resolve: {
						jobsBriefInfo: MyWorkJobBriefInfoResolver,
						isVendor: IsVendorResolver,
						hasJobShifts: HasJobShiftsResolver,
						accountInfo: MyWorkAccountInfoResolver,
						accountRouteUrls: AccountRouteUrlResolver,
						hasUserAcceptedTerms: HasAcceptedTermsResolver
					},
					pathMatch: 'full',
					data: {
						authPages: [AuthPage.Deficiencies, AuthPage.MyWork, AuthPage.SiteNotes]
					}
				},
				{
					path: 'terms-of-use',
					component: TermsOfUseComponent,
					resolve: {
						termsOfUse: TermsOfUseResolver
					}
				}
				]
			}, {
				path: 'site-notes/:jobId',
				children: [{
					path: '',
					component: SiteNotesComponent,
					resolve: {
						siteNotes: SiteNotesListResolver,
						accountInfo: SiteNotesAccountInfoResolver,
						accountRouteUrls: AccountRouteUrlResolver
					},
					pathMatch: 'full',
					data: {
						authPages: [AuthPage.Deficiencies, AuthPage.MyWork, AuthPage.SiteNotes]
					}
				}, {
					path: 'add',
					component: SiteNoteAddComponent,
					resolve: {
						accountInfo: SiteNotesAccountInfoResolver
					},
					pathMatch: 'full',
					data: {
						authPages: [AuthPage.Deficiencies, AuthPage.MyWork, AuthPage.SiteNotes]
					}
				}, {
					path: ':siteNoteId',
					children: [
						{
							path: '',
							component: SiteNoteViewComponent,
							resolve: {
								siteNote: SiteNoteItemResolver,
							}
						},
						{
							path: 'edit',
							component: SiteNoteAddComponent,
							resolve: {
								siteNote: SiteNoteItemResolver,
							}
						}, {
							path: 'complete',
							component: SiteNoteCompletionComponent,
							resolve: {
								siteNote: SiteNoteItemResolver
							}
						}]
				},
				{
					path: '**',
					redirectTo: '',
					pathMatch: 'full'
				}]
			}, {
				path: 'deficiencies',
				resolve: {
					deficiencies: DeficienciesListResolver,
					accountInfo: DeficienciesAccountInfoResolver
				},
				children: [{
					path: '',
					component: DeficienciesComponent,
					pathMatch: 'full',
					data: {
						authPages: [AuthPage.Deficiencies, AuthPage.MyWork, AuthPage.SiteNotes]
					},
					resolve: {
						accountRouteUrls: AccountRouteUrlResolver
					}
				}]
			}, {
				path: 'site-note',
				children: [{
					path: '',
					component: SiteNoteViewComponent,
					resolve: {
						siteNote: SiteNoteReadonlyResolver,
					}
				}]
			}, {
				path: 'deficiency',
				component: DeficiencyViewComponent,
				resolve: {
					deficiency: DeficiencyItemResolver
				}
			}, {
				path: 'board',
				data: {
					pageType: PageType.BoardMember
				},
				resolve: {
					jobDetails: BoardJobResolver
				},
				children: [
					{
						path: '',
						component: JobDetailsComponent
					}, {
						path: 'proposals',
						children: [
							{
								path: '',
								component: ProposalsQueueComponent,
								resolve: {
									proposals: BoardProposalsResolver
								}
							},
							{
								path: 'details',
								resolve: {
									proposal: BoardProposalResolver
								},
								children: [
									{
										path: '',
										component: BoardProposalsComponent,
									}, {
										path: 'thread',
										resolve: {
											thread: ProposalBoardThreadResolver
										},
										component: ProposalNoteThreadComponent
									}
								]
							}, {
								path: '**',
								redirectTo: ''
							}
						]
					}, {
						path: 'property-management',
						component: ContactsListComponent,
						resolve: {
							contacts: ProposalRelevantContactsResolver
						},
						data: {
							pageTitle: 'Property Management'
						}
					}, {
						path: '**',
						redirectTo: ''
					}
				]
			}, {
				path: 'job',
				data: {
					pageType: PageType.Customer
				},
				resolve: {
					myWorkUrl: MyWorkUrlResolver,
					jobDetails: JobsResolver,
					customerPreferences: CustomerPreferencesResolver,
				},
				children: [
					{
						path: '',
						component: JobDetailsComponent,
					}, {
						path: 'status',
						component: ChangeStatusComponent,
						resolve: {
							canCompleteJob: CanCompleteJobResolver
						}
					}, {
						path: 'date',
						component: ChangeEtaComponent,
					}, {
						path: 'document',
						children: [{
							path: '',
							component: AddDocumentsComponent
						}, {
							path: 'cloud',
							component: MyCloudComponent,
							resolve: {
								documents: CloudDocumentsResolver
							}
						}]
					}, {
						path: 'proposals',
						children: [{
							path: '',
							component: ProposalsQueueComponent,
							resolve: {
								proposals: CustomerProposalsResolver
							}
						}, {
							path: 'create',
							children: [{
								path: '',
								component: BoardProposalFormComponent,
							}, {
								path: 'documents',
								component: DocumentSelectionComponent,
								resolve: {
									jobDocuments: ProposalDocumentsResolver
								}
							}]
						}, {
							path: 'members',
							component: ContactsListComponent,
							resolve: {
								contacts: BoardMembersResolver
							},
							data: {
								pageTitle: 'Board Members',
								noContactsMessage: 'There are no board members!'
							}
						}, {
							path: ':proposalId/details',
							resolve: {
								proposal: CustomerProposalResolver
							},
							children: [{
								path: '',
								component: BoardProposalsComponent
							}, {
								path: 'thread',
								component: ProposalNoteThreadComponent,
								resolve: {
									thread: ProposalCustomerThreadResolver
								}
							}]
						}]
					}, {
						path: 'notes',
						children: [
							{
								path: '',
								component: CommentFollowUpComponent
							}, {
								path: '**',
								redirectTo: ''
							}
						]
					}, {
						path: 'collaborate',
						children: [
							{
								path: '',
								component: RequestUpdateComponent,
								resolve: {
									lastRequestUpdateChoice: RequestUpdateResolver
								}
							}, {
								path: 'assignees',
								component: AssigneesComponent,
							}, {
								path: 'thread',
								component: NoteThreadComponent,
								resolve: {
									noteThread: NoteThreadResolver
								}
							}, {
								path: '**',
								redirectTo: ''
							}
						]
					}, {
						path: 'forms',
						component: FormsComponent,
						resolve: {
							formTemplates: FormsResolver
						}
					}, {
						path: 'digital-log',
						children: [
							{
								path: '',
								component: DigitalLogFormRequestsComponent,
								runGuardsAndResolvers: 'always',
								resolve: {
									formRequests: DigitalLogFormRequestsActiveResolver,
									onDemandForms: DigitalLogOnDemandFormResolver,
									configOnDemandForms: DigitalLogConfigurationOnDemandFormResolver,
									accountRouteUrls: AccountRouteUrlResolver,
									accountInfo: SiteNotesAccountInfoResolver,
									canConfigureRounds: ConfigureRoundsUserRightResolver,
									profileGroups: DigitalLogConfigurationProfileGroupsResolver,
									onDemandFormsCount: DigitalLogOnDemandFormCountResolver
								},
								data: {
									authPages: [AuthPage.Deficiencies, AuthPage.MyWork, AuthPage.SiteNotes]
								}
							}, {
								path: 'calendar',
								component: DigitalLogFormCalendarComponent,
								resolve: {
									formRequests: DigitalLogFormRequestsResolver
								}
							}, {
								path: ':jobDigitalLogFormRequestId/form',
								component: DigitalLogFormComponent,
								resolve: {
									formDetails: DigitalLogFormResolver
								}
							}, {
								path: ':jobDigitalLogFormRequestId/form/photos',
								component: DigitalLogFormPhotosComponent,
								resolve: {
									photos: DigitalLogFormPhotosResolver
								}
							}, {
								path: 'add',
								component: DigitalLogOnDemandAddComponent,
								resolve: {
									onDemandForms: DigitalLogOnDemandFormResolver
								},
								data: {
									isConfigurationView: false
								}
							},
							{
								path: 'config',
								component: DigitalLogOnDemandAddComponent,
								resolve: {
									onDemandForms: DigitalLogConfigurationOnDemandFormResolver,
									canConfigureRounds: ConfigureRoundsUserRightResolver,
									configurationProfile: DigitalLogConfigurationProfileResolver,
									profileGroups: DigitalLogConfigurationProfileGroupsResolver
								},
								data: {
									isConfigurationView: true
								}
							},
							{
								path: 'documents',
								component: FieldsAttachmentsListComponent,
								resolve: {
									fields: FieldsAttachmentsResolver,
								},
								data: {
									isConfigurationView: true
								}
							},
							{
								path: '**',
								redirectTo: ''
							}
						]
					}, {
						path: '**',
						redirectTo: ''
					}
				]
			}, {
				path: 'job-update',
				data: {
					pageType: PageType.AssigneeOrVendor
				},
				resolve: {
					jobDetails: JobsResolver,
					customerPreferences: CustomerPreferencesResolver,
					isVendor: IsVendorResolver,
					myWorkUrl: MyWorkUrlResolver
				},
				children: [
					{
						path: '',
						component: JobDetailsComponent,
					}, {
						path: 'status',
						component: ChangeStatusComponent,
					}, {
						path: 'date',
						component: ChangeEtaComponent,
					}, {
						path: 'document',
						children: [{
							path: '',
							component: AddDocumentsComponent
						}, {
							path: 'cloud',
							component: MyCloudComponent,
							resolve: {
								documents: CloudDocumentsResolver
							}
						}]
					}, {
						path: 'notes',
						children: [
							{
								path: '',
								component: CommentFollowUpComponent,
							}, {
								path: 'contacts',
								component: ContactsListComponent,
								resolve: {
									contacts: ContactsResolver
								}
							}, {
								path: '**',
								redirectTo: ''
							}
						]
					}, {
						path: 'forms',
						component: FormsComponent,
						resolve: {
							formTemplates: FormsResolver
						}
					}, {
						path: 'digital-log',
						children: [
							{
								path: '',
								component: DigitalLogFormRequestsComponent,
								runGuardsAndResolvers: 'always',
								resolve: {
									formRequests: DigitalLogFormRequestsActiveResolver,
									onDemandForms: DigitalLogOnDemandFormResolver,
									configOnDemandForms: DigitalLogConfigurationOnDemandFormResolver,
									accountRouteUrls: AccountRouteUrlResolver,
									accountInfo: SiteNotesAccountInfoResolver,
									canConfigureRounds: ConfigureRoundsUserRightResolver,
									profileGroups: DigitalLogConfigurationProfileGroupsResolver,
									onDemandFormsCount: DigitalLogOnDemandFormCountResolver
								},
								data: {
									authPages: [AuthPage.Deficiencies, AuthPage.MyWork, AuthPage.SiteNotes]
								}
							}, {
								path: 'calendar',
								component: DigitalLogFormCalendarComponent,
								resolve: {
									formRequests: DigitalLogFormRequestsResolver
								}
							}, {
								path: ':jobDigitalLogFormRequestId/form',
								component: DigitalLogFormComponent,
								resolve: {
									formDetails: DigitalLogFormResolver
								}
							}, {
								path: ':jobDigitalLogFormRequestId/form/photos',
								component: DigitalLogFormPhotosComponent,
								resolve: {
									photos: DigitalLogFormPhotosResolver
								}
							}, {
								path: 'add',
								component: DigitalLogOnDemandAddComponent,
								resolve: {
									onDemandForms: DigitalLogOnDemandFormResolver
								},
								data: {
									isConfigurationView: false
								}
							},
							{
								path: 'config',
								component: DigitalLogOnDemandAddComponent,
								resolve: {
									onDemandForms: DigitalLogConfigurationOnDemandFormResolver,
									canConfigureRounds: ConfigureRoundsUserRightResolver,
									configurationProfile: DigitalLogConfigurationProfileResolver,
									profileGroups: DigitalLogConfigurationProfileGroupsResolver
								},
								data: {
									isConfigurationView: true
								}

							},
							{
								path: 'documents',
								component: FieldsAttachmentsListComponent,
								resolve: {
									fields: FieldsAttachmentsResolver,
								},
								data: {
									isConfigurationView: true
								}
							},
							{
								path: '**',
								redirectTo: ''
							}
						]
					}, {
						path: '**',
						redirectTo: ''
					}
				]
			}, {
				path: 'follow-up',
				resolve: {
					followUp: FollowUpResolver
				},
				children: [
					{
						path: '',
						component: FollowUpDetailsComponent,
					}, {
						path: 'edit',
						component: FollowUpEditComponent,
					}, {
						path: '**',
						redirectTo: ''
					}
				]
			}, {
				path: 'binder',
				children: [{
					path: '',
					component: VirtualBinderWizardComponent,
					resolve: {
						binderWizardDetails: BinderWizardDetailsResolver
					}
				}, {
					path: ':code',
					component: VirtualBinderConfirmationComponent
				}]
			}, {
				path: 'binder-viewer',
				children: [{
					path: '',
					component: BinderViewerComponent,
					resolve: {
						binderSetupData: BinderSetupDataResolver,
						binderClassification: BinderClassificationResolver,
						binderDetails: BinderDetailsResolver,
						binderTargetEmail: BinderTargetEmailResolver,
						binderQRScanHistory: BinderQrScanHistoryResolver,
						hasAccesToQRScans: BinderQrScansAccessResolver,
						hasWorkToDo: HasWorkToDoResolverResolver,
						isBinderAndCustomerLegacy: IsBinderAndCustomerLegacy,
						hasCustomerPermission: HasCustomerPermissionResolver,
						hasBinderUserPermission: HasBinderUserPermissionResolver
					}
				},
				{
					path: 'digital-logbooks',
					component: DigitalLogbookComponent,
					resolve: {
						digitalLogbooks: DigitalLogbooksResolver,
						binderDetails: BinderDetailsResolver
					}
				}]
			},
			{
				path: 'binder-session',
				children: [
					{
					path: '',
					component: BinderSessionComponent,
					canActivate: [BinderSessionGuard],
					resolve: {
						binderSetupData: BinderSessionSetupDataResolver,
						binderClassification: BinderSessionClassificationResolver,
						binderDetails: BinderSessionDetailsResolver
						}
					},
					{
						path: 'status',
						component: BinderSessionStatusComponent,
						resolve: { BinderSessionStatusResolver }
					},
					{
						path: 'confirmation-required',
						component: BinderSessionConfirmationComponent,
						resolve: { BinderSessionConfirmationResolver }
					},
					{
						path: ':code/confirm',
						component: BinderSessionCodeComponent,
						resolve: { BinderSessionCodeResolver }
					}
				]
			},
			{
				path: 'unregister',
				component: DeleteUserAccountComponent,
				resolve: {
					user: DeleteUserAccountResolver
				}
			},
			{
				path: 'procedure-form-bypass',
				resolve: {
					procedureFormBypassDetails: ProcedureFormBypassResolver
				},
				children: [
					{
						path: '',
						component: ProcedureFormBypassComponent
				}, {
					path: 'reject',
					children: [
						{
							path: '',
							component: RejectBypassRequestComponent
						}, {
							path: '**',
							redirectTo: ''
						}
					]
				}]
			},			
			{
				path: 'procedure-form-validations-skip',
				resolve: {
					procedureFormValidationsSkipDetails: ProcedureFormValidationsSkipResolver
				},
				children: [
					{
						path: '',
						component: ProcedureFormValidationsSkipComponent
				}, {
					path: 'reject',
					children: [
						{
							path: '',
							component: RejectValidationsSkipRequestComponent
						}, {
							path: '**',
							redirectTo: ''
						}
					]
				}]
			},
			{
				path: 'procedure-pre-approval',
				resolve: {
					procedurePreApprovalsDetails: ProcedurePreApprovalResolver
				},
				children: [
					{
						path: '',
						component: ProcedurePreApprovalComponent
				}, {
					path: 'reject',
					children: [
						{
							path: '',
							component: RejectPreApprovalRequestComponent
						}, {
							path: '**',
							redirectTo: ''
						}
					]
				}]
			}, {
				path: 'procedure-confirmation',
				resolve: {
						procedureCopilotDetails: ProcedureCopilotConfirmationResolver
				},
				children: [
					{
						path: '',
						component: ProcedureCopilotConfirmationComponent
					}, {
						path:'pending-procedures',
						resolve: {
							copilotProcedures: CopilotConfirmationProceduresListResolver
						},
						component: CopilotConfirmationProceduresListComponent
					},
					{
						path: ':jobProcedureFormId/form-details',
						component: ProcedureStepFormDetailsComponent,
						resolve: {
							formDetails: ProcedureStepFormDetailsResolver
						}
					}
			]
			}
			, {
				path: 'procedure-summary-review',
				resolve: {
						summaryReviewProcedure: ProcedureSummaryReviewResolver
				},
				children: [
					{
						path: '',
						component: ProcedureSummaryReviewComponent
					},
					{
						path: ':jobProcedureFormId/form-details',
						component: ProcedureStepFormDetailsComponent,
						resolve: {
							formDetails: ProcedureStepFormDetailsResolver
						}
					}
			]
			}
			, {
				path: '**',
				redirectTo: ''
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
